import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="mx-auto p-4">
      {/* <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1> */}
      <p className="text-gray-600">Effective Date: 1 January 2025</p>
      <p>
        FindNigeriaProperties.com (“we,” “our,” or “us”) values your privacy and
        is committed to protecting your personal data in compliance with the
        General Data Protection Regulation (GDPR). This Privacy Policy explains
        how we collect, use, and protect your information when you use our
        platform (the “Platform”).
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. Introduction</h2>
      <p>This Privacy Policy outlines:</p>
      <ul className="list-disc pl-5">
        <li>What personal data we collect and process.</li>
        <li>How we use your personal data.</li>
        <li>Your rights under GDPR.</li>
        <li>How to contact us regarding your data.</li>
      </ul>
      <p>
        By using the Platform, you consent to the collection and use of your
        personal data as described in this Privacy Policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6">2. Data Controller</h2>
      <p>
        FindNigeriaProperties.com is the data controller responsible for
        processing your personal data.
      </p>
      <p>
        <strong>Contact Information:</strong>
      </p>
      <ul className="list-disc pl-5">
        <li>
          Email:&nbsp;
          <a
            href="mailto:support@FindNigeriaProperties.com"
            className="text-blue-500"
          >
            support@FindNigeriaProperties.com
          </a>{" "}
        </li>
        <li>Address: 7th Floor, CBC Towers, Lekki Phase 1, Lekki</li>
        <li>Phone: +234 (806) 070 6906</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">3. Data We Collect</h2>
      <h3 className="text-xl font-medium mt-4">
        3.1. Personal Data Provided by You:
      </h3>
      <ul className="list-disc pl-5">
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Address</li>
        <li>Payment details</li>
        <li>Investment preferences</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">
        3.2. Automatically Collected Data:
      </h3>
      <ul className="list-disc pl-5">
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Operating system</li>
        <li>Device information</li>
        <li>Usage data</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">
        3.3. Cookies and Tracking Technologies:
      </h3>
      <p>
        We use cookies and similar technologies to improve your experience. For
        detailed information, refer to our Cookie Policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        4. Legal Basis for Processing
      </h2>
      <ul className="list-disc pl-5">
        <li>
          <strong>Consent:</strong> When you provide explicit consent.
        </li>
        <li>
          <strong>Contract Performance:</strong> To fulfill our contractual
          obligations.
        </li>
        <li>
          <strong>Legal Obligations:</strong> To comply with applicable laws.
        </li>
        <li>
          <strong>Legitimate Interests:</strong> To enhance services, improve
          security, and prevent fraud.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">5. How We Use Your Data</h2>
      <ul className="list-disc pl-5">
        <li>To create and manage your account.</li>
        <li>To process transactions and provide services.</li>
        <li>To communicate with you.</li>
        <li>To improve the Platform and user experience.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">6. Data Sharing</h2>
      <p>We may share your data with:</p>
      <ul className="list-disc pl-5">
        <li>Service providers for payments, hosting, and marketing.</li>
        <li>Legal authorities when required.</li>
        <li>In case of business transfers.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">7. Data Retention</h2>
      <p>We retain personal data as long as necessary:</p>
      <ul className="list-disc pl-5">
        <li>Account information: Retained until account deletion.</li>
        <li>Transaction records: Retained for [Insert Number] years.</li>
        <li>Marketing data: Retained until you withdraw consent.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">8. Your Rights Under GDPR</h2>
      <ul className="list-disc pl-5">
        <li>Right to Access</li>
        <li>Right to Rectification</li>
        <li>Right to Erasure</li>
        <li>Right to Restrict Processing</li>
        <li>Right to Data Portability</li>
        <li>Right to Object</li>
        <li>Right to Withdraw Consent</li>
        <li>Right to Lodge a Complaint</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">9. Security Measures</h2>
      <p>
        We implement robust security measures, including encryption and
        restricted access, to protect your data.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        10. Marketing Communications
      </h2>
      <p>
        We&apos;ll keep you in the loop with valuable updates and opportunities
        from FNP through channels like emails, push notifications etc. If you
        ever change your mind, unsubscribing is just a click away.
      </p>

      <h2 className="text-2xl font-semibold mt-6">11. Contact Us</h2>
      <p>For questions or concerns about this Privacy Policy, contact us at:</p>
      <ul className="list-disc pl-5 max-w-screen text-wrap">
        <li>
          Email:&nbsp;
          <br className="block md:hidden" />
          <a
            href="mailto:compliance@FindNigeriaProperties.com"
            className="text-blue-500"
          >
            compliance@FindNigeriaProperties.com
          </a>{" "}
        </li>
        <li>Phone: +234 (806) 070 6906</li>
        <li>Address: 7th Floor, CBC Towers, Lekki Phase 1, Lekki</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
